export default __webpack_public_path__ + "static/media/Mark-4-HUD-Altitude Range.d28e46c7.jpg";